import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { PanelComponent } from './pages/panel.component';
import { authGuard } from './guards/auth/auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '' },
  {
    path: '',
    component: PanelComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/panel.module').then((m) => m.PanelModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
